export default "__VITE_ASSET__CeUwJuKE__"